var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReactLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 41,
    viewBox: "0 0 45 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_389_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4798 24.4596C24.6929 24.4596 26.4869 22.6655 26.4869 20.4525C26.4869 18.2394 24.6929 16.4453 22.4798 16.4453C20.2667 16.4453 18.4727 18.2394 18.4727 20.4525C18.4727 22.6655 20.2667 24.4596 22.4798 24.4596Z",
    fill: "#61DAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4783 28.6627C34.3534 28.6627 43.98 24.987 43.98 20.4529C43.98 15.9188 34.3534 12.2432 22.4783 12.2432C10.6032 12.2432 0.976562 15.9188 0.976562 20.4529C0.976562 24.987 10.6032 28.6627 22.4783 28.6627Z",
    stroke: "#61DAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3691 24.5573C21.3066 34.8415 29.3031 41.3406 33.2298 39.0735C37.1564 36.8064 35.5263 26.6317 29.5887 16.3476C23.6512 6.06348 15.6547 -0.435623 11.728 1.83144C7.80138 4.0985 9.43151 14.2732 15.3691 24.5573Z",
    stroke: "#61DAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3693 16.3478C9.43175 26.6319 7.80161 36.8067 11.7283 39.0737C15.6549 41.3408 23.6514 34.8417 29.589 24.5576C35.5265 14.2734 37.1567 4.09871 33.23 1.83165C29.3033 -0.43541 21.3068 6.0637 15.3693 16.3478Z",
    stroke: "#61DAFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_389_102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.9581,
    height: 40,
    fill: "white",
    transform: "translate(0 0.452148)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactLogo);
export default __webpack_public_path__ + "static/media/react-logo.08a2428f4cfb0cc87c34b068f2416048.svg";
export { ForwardRef as ReactComponent };